import { Fragment } from 'react';
import { ConditionalPropResponse, Episode } from './apiService';
import EpisodeItem from './EpisodeItem';
import { Divider, Row } from './styles';

export default function EpisodeList({ episodes = [], reactions }: EpisodeListProps) {
  if (!episodes.length) return <>...</>;

  return (
    <Row cols={{ xs: 1, sm: 2, md: 4, xl: 5 }}>
      {!!episodes?.length &&
        episodes.map((episode) => (
          <Fragment key={episode.id}>
            <EpisodeItem {...episode} flags={getFlags(episode.id, reactions)} />
            <Divider className="mobile-only" mt=".75rem" />
          </Fragment>
        ))}
    </Row>
  );
}

const getFlags = (id: string, reactions: EpisodeListProps['reactions']) => reactions?.[id]?.conditional_flag;

interface EpisodeListProps {
  episodes?: Episode[];
  reactions?: Record<string, Pick<ConditionalPropResponse, 'conditional_flag'>>;
}
